import type { ReminderPayload } from '../services/ReminderService';

type SerializableValue = string | null | undefined;

const serializePropertiesValue = (value: unknown): SerializableValue => {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value);
  } catch {
    return undefined;
  }
};

export const buildFullReminderPayload = (
  reminder: Record<string, any> | null | undefined,
  overrides: Partial<ReminderPayload> = {}
): ReminderPayload => {
  const base = reminder && typeof reminder === 'object' ? { ...reminder } : {};
  const payload: Record<string, any> = {
    ...base,
    ...overrides,
  };
  const normalizedProperties = serializePropertiesValue(payload.properties);
  if (normalizedProperties === undefined) {
    delete payload.properties;
  } else {
    payload.properties = normalizedProperties;
  }
  return payload as ReminderPayload;
};
